import { backendClient } from '@/lib/api-client';

const calendarSync = async () => {
    try {
        const response = await backendClient.post('/deadlines/reconcile-calendars');
        const result = response.data;

        // Log success at debug level (can be filtered in production)
        if (result.status === 'completed' && result.calendars_reconciled > 0) {
            console.debug(
                `Calendar sync completed: ${result.calendars_reconciled} calendars reconciled`
            );
        }
    } catch (error) {
        console.error('Background calendar sync error:', error);
    }
};

export default calendarSync;